// extracted by mini-css-extract-plugin
export default {"Header__Section":"Header_Header__Section__ViT7Y","Main__Title":"Header_Main__Title__sDCyr","Description":"Header_Description__55QOt","Header__Image":"Header_Header__Image__jVobE"};